import ISvgProps from 'src/SvgLoader/ISvgProps';

export const SubmitIcon = (props: ISvgProps) => (
	<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M0.810433 6.08606C0.397184 5.94813 0.393226 5.72539 0.818349 5.58349L15.9288 0.540406C16.3476 0.400893 16.5875 0.635529 16.4703 1.04614L12.1526 16.1754C12.0338 16.5947 11.7924 16.609 11.6151 16.2111L8.76982 9.79981L13.5198 3.45829L7.18649 8.21443L0.810433 6.08606Z"
			fill={props.primaryColor}
		/>
	</svg>
);
